import CAMCFundDistributorTable from "./camc-fund-distributor-table";

class WebsiteCAMCFundDistributorTable extends CAMCFundDistributorTable {
    renderFundDistributorTable(fundDistributorsData) {
        if (fundDistributorsData.data && fundDistributorsData.data.length) {
            fundDistributorsData = fundDistributorsData.data;
            if (Foundation.MediaQuery.is("small only")) {
                this.initTablesInMobile(fundDistributorsData);
            } else {
                this.initTables(fundDistributorsData);
            }
        }
    }

    initTables(data) {
        let header = `
        <thead class="fund-distributor__header">
            <tr>
                <th>渠道名称</th>
                <th>客服电话</th>
            </tr>
        </thead>
        <tbody></tbody>
        `;
        $("table.fund-distributor").append(header);
        let item = `
            <tr class="fund-distributor__item">
                <td class="fund-distributor__name"></td>
                <td class="fund-distributor__tel"></td>
            </tr>
        `;
        if (data && data.length) {
            for (let i = 0; i < data.length; i++) {
                $("table.fund-distributor tbody").append(item);
                $("td.fund-distributor__name").eq(i).html(data[i].name);

                // TODO: Remove distributor url function temporary
                // let urlText = data[i].urlText.trim();
                // let urlHref = data[i].url.trim();
                // if (urlHref.indexOf('http') == -1) {
                //     urlHref = "http://" + data[i].url.trim();
                // }
                // let urlHref = data[i].url ? data[i].url.trim() : "";
                // let urlsDiv = "";
                // if (data[i].url && data[i].url.indexOf(",") > -1) {
                //     let urls = data[i].url.split(",");
                //     for (var j = 0; j < urls.length; j++) {
                //         if (urls[j].indexOf('http') == -1) {
                //             urlsDiv += '<a target="_blank" href=http://' + urls[j].trim() + '>' + urls[j] + '</a>,';
                //         } else {
                //             urlsDiv += '<a target="_blank" href="' + urls[j].trim() + '">' + urls[j] + '</a>,';
                //         }
                //     }
                // } else {
                //     if (urlHref == "") {
                //         urlsDiv = "";
                //     } else if (urlHref.indexOf('http') == -1) {
                //         urlsDiv = '<a target="_blank" href=http://' + urlHref.trim() + '>' + urlHref + '</a>,';
                //     } else {
                //         urlsDiv = '<a target="_blank" href="' + urlHref.trim() + '">' + data[i].urlText + '</a>,';
                //     }
                // }
                // urlsDiv = urlsDiv.substr(0, urlsDiv.length - 1);
                // $("td.fund-distributor_site").eq(i).html(urlsDiv);

                $("td.fund-distributor__tel").eq(i).html(data[i].phoneNo);
            }
        }
    }

    initTablesInMobile(data) {
        let header = `
        <thead class="fund-distributor__header">
            <tr>
                <th>渠道名称</th>     
            </tr>
        </thead>
        `;
        $("table.fund-distributor").append(header);
        let item = `
        <tbody>
            <tr class="fund-distributor__item">
                <td class="fund-distributor__name"></td>         
            </tr>
        </tbody>
        `;
        if (data && data.length) {
            for (let i = 0; i < data.length; i++) {
                $("table.fund-distributor").append(item);
                let phonesDiv = "";
                if (data[i].phoneNo && data[i].phoneNo.indexOf(",") > -1) {
                    let phoneNos = data[i].phoneNo.split(",");
                    for (var j = 0; j < phoneNos.length; j++) {
                        phonesDiv += '<a target="_blank" href=tel:"' + phoneNos[j] + '">' + phoneNos[j] + "</a>,";
                    }
                } else {
                    if (data[i].phoneNo) {
                        phonesDiv =
                            '<a target="_blank" href=tel:"' + data[i].phoneNo + '">' + data[i].phoneNo + "</a>,";
                    } else {
                        phonesDiv = "";
                    }
                }
                phonesDiv = phonesDiv.substr(0, phonesDiv.length - 1);

                // TODO: Remove distributor url function temporary
                // let urlsDiv = "";
                // let urlHref = data[i].url ? data[i].url.trim() : "";

                // if (data[i].url && data[i].url.indexOf(",") > -1) {
                //     let urls = data[i].url.split(",");
                //     for (var j = 0; j < urls.length; j++) {
                //         if (urls[j].indexOf('http') == -1) {
                //             urlsDiv += '<a target="_blank" href=http://' + urls[j].trim() + '>' + urls[j] + '</a>,';
                //         } else {
                //             urlsDiv += '<a target="_blank" href="' + urls[j].trim() + '">' + urls[j] + '</a>,';
                //         }
                //     }
                // } else {
                //     if (urlHref == "") {
                //         urlsDiv = "";
                //     } else if (urlHref.indexOf('http') == -1) {
                //         urlsDiv = '<a target="_blank" href=http://' + urlHref.trim() + '>' + urlHref + '</a>,';
                //     } else {
                //         urlsDiv = '<a target="_blank" href="' + urlHref.trim() + '">' + data[i].urlText + '</a>,';
                //     }
                // }
                // urlsDiv = urlsDiv.substr(0, urlsDiv.length - 1);
                // $("td.fund-distributor__name").eq(i).html('<div><div>' + data[i].name + '</div><div>' + urlsDiv + '</div><div class = "distributor-phone" style="color:#016fad">' + phonesDiv + '</div></div>');

                $("td.fund-distributor__name")
                    .eq(i)
                    .html(
                        "<div>" +
                            data[i].name +
                            '</div><div class = "fund-distributor__phone" style="color:#016fad">' +
                            phonesDiv +
                            "</div>",
                    );
            }
        }
    }

    errorHandler() {
        showApiMessageing($(".camc-fund-distributor-table"));
    }
}

document.addEventListener("DOMContentLoaded", () => {
    if (window.fundCode) {
        const camcFundDistributorTable = new WebsiteCAMCFundDistributorTable(window.fundCode);
        camcFundDistributorTable.render();
    }
});
